import { FormRow } from 'framework/ui/layout';
import { ClearAfterUnmountWrapper } from 'framework/form';
import { FeedbackAttachmentUploaderInput, TimelineFeedbackWysiwygInput } from 'domain/shared/employee';
import { Box } from '@mui/material';

const Div = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <div className={className}>{children}</div>
);

const FullWidthFormRow = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <FormRow colMd={12} colXl={12} className={className}>
    {children}
  </FormRow>
);

interface EvaluationDetailsFormProps {
  isPageForm?: boolean;
  source?: string;
}

const EvaluationDetailsForm: React.FC<EvaluationDetailsFormProps> = ({
  isPageForm,
  source = 'feedbackGrades.general',
}) => {
  const TimelineFeedbackWysiwygInputWrapper = isPageForm ? FullWidthFormRow : Div;

  return (
    <Box sx={{ width: '100%', '& span': { fontWeight: 500 } }}>
      <TimelineFeedbackWysiwygInputWrapper>
        <ClearAfterUnmountWrapper>
          <TimelineFeedbackWysiwygInput
            artifactsSource={`${source}.attachmentsIds`}
            source={`${source}.description`}
            label="Feedback and references"
            tooltip="Write down detailed feedback about your colleague's work. The feedback will be shared with the People manager, so please give them context and objective references, e.g. documents and ticket numbers."
          />
        </ClearAfterUnmountWrapper>
      </TimelineFeedbackWysiwygInputWrapper>

      <ClearAfterUnmountWrapper>
        <FeedbackAttachmentUploaderInput
          label="Attach evidence for your feedback"
          source={`${source}.attachmentsIds`}
        />
      </ClearAfterUnmountWrapper>
    </Box>
  );
};

export default EvaluationDetailsForm;
